import styled from '@emotion/styled';

export const SkeletonWrapper = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
`;

